// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1qoytg60 {
  width: 17.5%;
}
._1qoytg61::before {
  content: "\\2022\\2022\\2022\\2022";
  display: block;
  letter-spacing: 1px;
}
._1qoytg62 {
  position: relative;
  align-items: center;
  justify-content: space-between;
  background: var(--_18w76bw27);
  border: 1px var(--_18w76bw2a) solid;
  padding: var(--_18w76bwg) var(--_18w76bwg);
}
._1qoytg62::before {
  content: "";
  display: block;
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translate(-50%) rotate(-45deg);
  width: 12px;
  height: 12px;
  z-index: 1;
  background: white;
  border-left: 1px solid var(--_18w76bw2a);
  border-bottom: 1px solid var(--_18w76bw2a);
}
@media screen and (min-width: 768px) {
  ._1qoytg60 {
    width: 100px;
  }
  ._1qoytg62 {
    padding: var(--_18w76bwg) var(--_18w76bwy) var(--_18w76bwg) var(--_18w76bwh);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,mCAAmC;EACnC,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,wCAAwC;EACxC,0CAA0C;AAC5C;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,4EAA4E;EAC9E;AACF","sourcesContent":["._1qoytg60 {\n  width: 17.5%;\n}\n._1qoytg61::before {\n  content: \"\\2022\\2022\\2022\\2022\";\n  display: block;\n  letter-spacing: 1px;\n}\n._1qoytg62 {\n  position: relative;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--_18w76bw27);\n  border: 1px var(--_18w76bw2a) solid;\n  padding: var(--_18w76bwg) var(--_18w76bwg);\n}\n._1qoytg62::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: -6px;\n  left: 50%;\n  transform: translate(-50%) rotate(-45deg);\n  width: 12px;\n  height: 12px;\n  z-index: 1;\n  background: white;\n  border-left: 1px solid var(--_18w76bw2a);\n  border-bottom: 1px solid var(--_18w76bw2a);\n}\n@media screen and (min-width: 768px) {\n  ._1qoytg60 {\n    width: 100px;\n  }\n  ._1qoytg62 {\n    padding: var(--_18w76bwg) var(--_18w76bwy) var(--_18w76bwg) var(--_18w76bwh);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
